import React from 'react';
import { Modal } from 'antd';
const ModalCommon = ( {children, title, isModalOpen, setIsModalOpen} ) => {

  const handleCancel = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };
  return (
    <>
      <Modal title={title} onCancel={handleCancel} open={isModalOpen} footer={null}>
        {children}
      </Modal>
    </>
  );
};
export default ModalCommon;